import { USER_ACCESS_TYPE } from '~/configurations/constants';

const DICTIONARIES = {
  en: {
    already_have_an_account: 'Already have account?',
    choose_company: 'Choose company',
    dont_have_an_account_yet: 'Don\'t have account yet?',
    enter_otp_message: 'Enter verification code that we send to',
    enter_otp_new_password_message: 'Type the new password, then enter code\nverification that we send to',
    forgot_password: 'Forgot Password',
    login: 'Login',
    login_title_page: 'Login | Last-Mile Dashboard',
    logout: 'Logout',
    otp: 'Verification code',
    otp_mismatch: 'Incorrect verification code',
    otp_required_please_retry: 'Verification code required. Please retry',
    new_password: 'New Password',
    password: 'Password',
    password_verification_mismatch: 'Password verification mismatch',
    phone_number_unrecognized: 'Phone number not registered',
    phone_number_taken: 'Phone number already registered',
    register: 'Register',
    register_title_page: 'Register | Last-Mile Dashboard',
    retype_password: 'Retype Password',
    retype_new_password: 'Retype New Password',
    resend_otp: 'Resend Verification Code',
    resend_otp_countdown_message: 'Resend code in {{countdown}} seconds',
    reset_password_success: 'Password reset successfully',
    send_otp_failed: 'Error sending verification code',
    send_otp_success: 'Verification code sent',
    strong_password_pattern: 'Password must contain at least one special character, one number, one uppercase, and one lowercase letter',
    user_access_map: {
      [USER_ACCESS_TYPE.ADMIN]: 'ADMIN',
      [USER_ACCESS_TYPE.FULL_ACCESS]: 'FULL ACCESS',
      [USER_ACCESS_TYPE.FINANCE]: 'FINANCE',
      [USER_ACCESS_TYPE.RESTRICTED_ACCESS]: 'RESTRICTED ACCESS',
    },
  },
};

export default DICTIONARIES;
